const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  content: {
    ...theme.mainContent,
    maxWidth: "780px",
    width: "100%",
    margin: "0 auto",
    padding: "0px 10px",
  },
  header: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    background: "#fff",
    padding: "0px 10px",
    boxShadow: "0 4px 10px -4px rgba(0,0,0,.07)",
    "@media print": {
      display: "none",
    },
  },
  contentLG: {
    maxWidth: "1280px",
  },
  contentMD: {
    maxWidth: "1100px",
  },
  contentFull: {
    maxWidth: "1920px",
  },
}));
